export default __webpack_public_path__ + "static/media/Abstracto-orange.8b1e295a.svg";